import Vue from 'vue'
import calc from '@src/calc'

export const state = {
  all: [],
}

export const getters = {
  getIndex: (state) => (room, ratePlan) =>
    state.all.findIndex(
      (item) => item.id === room.id && item.ratePlanId === ratePlan.id
    ),
  getItem: (state, getters) => (room, ratePlan) => {
    const index = getters.getIndex(room, ratePlan)
    return state.all[index]
  },
  isEmpty: (state) => state.all.length < 1,
  getTotalRoom: (state) => (room) =>
    state.all
      .filter((item) => item.id === room.id)
      .reduce((prev, curr) => (prev += curr.qty), 0),
  cartItems: (state, getters, rootState, rootGetters) => {
    const loggedIn = rootGetters['auth/loggedIn']

    return state.all.map((item) => {
      const { room, ratePlan } = rootGetters['rooms/getRoomDetailByCart'](item)
      const rate = loggedIn ? ratePlan.rate.member : ratePlan.rate.promotion
      const extrabed = item.extrabed
        .map((qty, index) => {
          const roomNo = index + 1

          return {
            qty,
            room: roomNo,
            name: `${room.name} - Extra bed room ${roomNo}`,
            price: ratePlan.rate.extraBed
              ? calc.multiplyRate(ratePlan.rate.extraBed, qty)
              : 0,
          }
        })
        .filter((item) => item.qty > 0)

      return {
        id: item.id,
        ratePlanId: item.ratePlanId,
        promotionId: ratePlan.promotion
          ? ratePlan.promotion.id
          : ratePlan.promotion,
        qty: item.qty,
        name: `${room.name} - ${ratePlan.name}`,
        roomType: room.name,
        occupancy: ratePlan.occupancy,
        benefits: ratePlan.benefits,
        wifiIncluded: room.information.wifiIncluded,
        cancellation: ratePlan.cancellation,
        price: calc.multiplyRate(rate, item.qty),
        extrabed,
      }
    })
  },
  payload: (state, getters) =>
    getters.cartItems.map((item) => ({
      id: item.id,
      qty: item.qty,
      ratePlanId: item.ratePlanId,
      promotionId: item.promotionId,
      price: calc.payloadPrice(item.price),
      extraBeds: item.extrabed.map((item) => ({
        qty: item.qty,
        price: calc.payloadPrice(item.price),
        room: item.room,
      })),
    })),
  totalPriceInCart: (state, getters) =>
    getters.cartItems.reduce(
      (pre, cur) => {
        const extrabed = cur.extrabed.reduce(
          (ebPre, ebCur) => {
            ebPre.gross += ebCur.price.gross
            ebPre.discount += ebCur.price.discount
            ebPre.tax += ebCur.price.tax
            ebPre.service += ebCur.price.service
            ebPre.net += ebCur.price.net

            return ebPre
          },
          { gross: 0, discount: 0, tax: 0, service: 0, net: 0 }
        )

        if (!pre.currency) pre.currency = cur.price.currency

        pre.gross += cur.price.gross + extrabed.gross
        pre.discount += cur.price.discount + extrabed.discount
        pre.tax += cur.price.tax + extrabed.tax
        pre.service += cur.price.service + extrabed.service
        pre.net += cur.price.net + extrabed.net

        return pre
      },
      { currency: null, gross: 0, discount: 0, tax: 0, service: 0, net: 0 }
    ),
}

export const actions = {
  updateRoomCart: {
    root: true, // triggered by global action: roomCart
    handler({ commit, getters }, { room, ratePlan, qty, extrabed }) {
      const index = getters.getIndex(room, ratePlan)
      const item = {
        id: room.id,
        ratePlanId: ratePlan.id,
        qty,
        extrabed,
      }

      if (index < 0) {
        return commit('ADD_ROOM_ITEM', item)
      }

      if (qty === 0) {
        return commit('DELETE_ROOM_ITEM', index)
      }

      return commit('UPDATE_ROOM_ITEM_QTY', { index, item })
    },
  },
  clearCart: {
    root: true, // triggered by global action: clearAllCart
    handler({ commit }) {
      commit('CLEAR_CART')
    },
  },
}

export const mutations = {
  ADD_ROOM_ITEM(state, item) {
    state.all.push(item)
  },
  DELETE_ROOM_ITEM(state, index) {
    state.all.splice(index, 1)
  },
  UPDATE_ROOM_ITEM_QTY(state, { index, item }) {
    Vue.set(state.all, index, item)
  },
  CLEAR_CART(state) {
    state.all = []
  },
}
